<template>
    <div class="hosting-call-to-action" :class="{ 'compact': isCompactView }">
        <img
            v-if="!isCompactView"
            class="image"
            src="/images/shows/hosting-call-to-action.jpg"
        >

        <div class="content">
            <h3 class="call-to-action-header">
                {{ getTitle() }}
            </h3>

            <p>{{ getDescription() }}</p>

            <template v-if="!isCompactView">
                <slot />
            </template>

            <button
                type="button"
                class="btn is-green"
                @click.prevent="handleButtonClick"
            >
                {{ buttonLabel }}
            </button>
        </div>
    </div>
</template>
<script>
import { Feature, hasFeature } from '@/utils/show';
import { mapMutations, mapState } from 'vuex';
import { Step } from '@/utils/config/addShowModal';
import { steps } from '@/utils/config/upgradeShowModal';

export default {
    props: {
        show: {
            type: Object,
            default: () => ({}),
        },
        screen: {
            type: String,
            default: 'analytics',
        },
    },

    computed: {
        ...mapState({
            user: state => state.user || {},
        }),

        /**
         * Determines if the show has a hosting feature.
         *
         * @returns {boolean} `true` if the show has a hosting feature.
         */
        hasHosting() {
            return hasFeature(this.show, Feature.EasyHosting);
        },

        /**
         * Returns button label.
         *
         * @returns {string} Button label.
         */
        buttonLabel() {
            return this.hasHosting
                ? 'Migrate My Show'
                : 'Upgrade to Starter';
        },

        /**
         * Checks whether show details.
         *
         * @returns {boolean} Check result.
         */
        isCompactView() {
            if ('settings' === this.screen && this.hasHosting) {
                return true;
            }

            return false;
        },
    },

    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Gets the title.
         *
         * @returns {string} Component title.
         */
        getTitle() {
            if ('analytics' === this.screen) {
                return 'Looking for your podcast analytics?';
            }
            if ('settings' === this.screen) {
                return 'You’re missing out on free hosting!';
            }
        },

        /**
         * Gets the description.
         *
         * @returns {string} Component description.
         */
        getDescription() {
            if ('analytics' === this.screen) {
                return 'Host your podcast for free with Fusebox and you can view your analytics all in one place!';
            }
            if ('settings' === this.screen && ! this.hasHosting) {
                return 'Upgrade to Starter and migrate from your existing host to Fusebox — we’ll take care of the rest!';
            }
            if ('settings' === this.screen && this.hasHosting) {
                return 'Did you know your plan includes free podcast hosting?!';
            }
        },

        /**
         * Handles click event on button.
         */
        handleButtonClick() {
            if (this.hasHosting) {
                this.handleUpgradeHosting();
                return;
            }

            this.handleUpgradePlan();
        },

        /**
         * Handles hosting upgrade.
         */
        handleUpgradeHosting() {
            this.changeUIState({
                upgradeShowModal: {
                    show: this.show,
                    step: steps.intro,
                    visible: true,
                },
            });
        },

        /**
         * Handles plan upgrade.
         */
        handleUpgradePlan() {
            this.changeUIState({
                addShowModal: {
                    mode: 'upgrade',
                    show: this.show,
                    step: Step.Plans,
                    type: 'hosted',
                    visible: true,
                },
            });
        },
    },
};
</script>
